import {checkIfAlreadyBestMeleeCombatDamage} from "../../melee/checkIfAlreadyBestMeleeCombatDamage";
import {getMeleeCountedDiceRolls} from "../../melee/getMeleeDiceRolls";

const NO_IDS = [];

/**
 * Отряды игрока в ближнем бою, которые еще могут перебросить кости: у отряда
 * не потрачен жетон дополнительного снабжения, переброса еще не было, и на
 * костях не лучший результат (переброс тогда недоступен, как в
 * SelectedUnitMelee). Пустой список — по бою игроку делать больше нечего.
 *
 * @param {Array} units - отряды партии
 * @param {Array} pendingMeleeDamage - расчет ближних боев этапа
 * @param {string} playerId
 * @returns {string[]} id отрядов
 */
export const getMeleeRerollUnitIds = (units, pendingMeleeDamage, playerId) => {
  if (!playerId || !pendingMeleeDamage?.length) {
    return NO_IDS;
  }
  return pendingMeleeDamage
    .filter((action) => action.ownerId === playerId
      && !action.hasRerolled
      && !checkIfAlreadyBestMeleeCombatDamage(...getMeleeCountedDiceRolls(action))
      && (units || []).some((unit) => unit.id === action.unitId && unit.additionalSupply))
    .map((action) => action.unitId);
};
